module.exports = __webpack_public_path__ + "img/8f.ad1fd23e.png";